import { createAsyncThunk } from '@reduxjs/toolkit';
import rootAxios from '../../requests/rootAxios';

export const fetchAvailableCenters = createAsyncThunk(
  'centers/fetchAvailableCenters',
  async ({ branch, batchId }, { rejectWithValue }) => {
    try {
      const branchIds = branch.map((b) => `00${String(b.id)}`);
      const response = await rootAxios.post(
        '/user/getCenterListByBranchId',
        { branchIds }
      );

      return Array.isArray(response?.data?.data) ? response?.data?.data : [];
      // Assuming the API returns an array of centers. If not, it will be handled by the catch block or will return empty array.
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
